<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <v-snackbar v-model="showSnackBar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-card-title class="elevation-0">
              <span class="itemHeading">WILD BYTES</span>
              <v-spacer></v-spacer>
              <!-- <v-flex text-end align-self-center>
                              <v-btn color="#005f32" rounded outlined class="mb-4" @click="addTargets = true">
                                <span style="font-family: kumbhRegular;">Add Targets</span>
                              </v-btn>
                            </v-flex> -->
              <v-flex text-end align-self-center>
                <v-btn color="#005f32" rounded outlined class="mb-4" @click="addBlog = true">
                  <span style="font-family: kumbhRegular">Add WILD BYTES</span>
                </v-btn>
              </v-flex>
            </v-card-title>
            <!-- Table section -->

            <v-dialog v-model="addBlog" max-width="80%">
              <v-card>
                <v-card-title>
                  <span class="itemHeading">ADD WILD BYTES</span>
                </v-card-title>
                <v-card-text>
                  <v-form>
                    <v-text-field dense outlined v-model="title" label="Title" required></v-text-field>
                    <v-text-field dense outlined v-model="author" label="Author" required></v-text-field>
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="uploadedDate" label="Uploaded Date" append-icon="mdi-calendar" readonly
                          v-bind="attrs" v-on="on" dense outlined required></v-text-field>
                      </template>
                      <v-date-picker v-model="uploadedDate" @input="menu = false"></v-date-picker>
                    </v-menu>
                    <v-textarea v-model="subDescription" dense outlined label="Sub description" required></v-textarea>
                    <v-flex pt-6>
                      <v-file-input label="Upload Cover Image" dense outlined accept="image/*" @change="onFileChange"
                        :show-size="false" hide-details="auto">
                      </v-file-input>
                      <br />
                      <cropper v-if="imageSelected" ref="cropper" :src="imageURL"
                        :stencil-props="{ aspectRatio: 16 / 9 }" :resize-image="true" :background="true" />
                    </v-flex>
                    <!-- Begin new subcontents section -->
                    <div>
                      <div v-for="(sub, idx) in subcontents" :key="idx" class="mb-6 pa-4"
                        style="border:1px solid #eee; border-radius:8px;">
                        <div class="mb-2">
                          <label style="font-weight:bold;">Content</label>
                          <vue-editor v-model="sub.content" style="font-size: 14px"></vue-editor>
                        </div>
                        <div class="mb-2">
                          <label style="font-weight:bold;">Image</label>
                          <v-file-input dense outlined accept="image/*" :label="'Upload Image for Content ' + (idx + 1)"
                            @change="onSubcontentFileChange($event, idx)" :show-size="false"
                            hide-details="auto"></v-file-input>
                          <cropper v-if="sub.imageSelected" :ref="'subCropper' + idx" :src="sub.imageURL"
                            :resize-image="true" :background="true" />
                        </div>
                        <div class="mb-2">
                          <label style="font-weight:bold;">Image Caption</label>
                          <v-text-field dense outlined v-model="sub.imagecaption" label="Image Caption"></v-text-field>
                        </div>
                        <div v-if="subcontents.length > 1" class="text-right">
                          <v-btn small color="red" text @click="removeSubcontent(idx)">
                            Remove
                          </v-btn>
                        </div>
                      </div>
                      <v-btn color="#005f32" outlined small @click="addSubcontent">
                        Add More
                      </v-btn>
                    </div>
                    <!-- End new subcontents section -->
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="addBlog = false">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="addBlogs">Submit</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-layout wrap justify-center px-4>
              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <!-- Church Detail Card Section -->
                    <v-layout wrap justify-start v-if="bloglist?.length > 0">
                      <v-flex xs12 sm6 md4 lg3 v-for="(item, index) in bloglist" :key="index"
                        @click="redirectToViewPage(item)" class="d-flex mb-3">
                        <v-layout wrap justify-center>
                          <v-flex xs12 pa-2>
                            <v-card class="video-card" elevation="1" height="100%">
                              <v-flex xs12>
                                <v-img :src="mediaURL + item.images[0]" max-height="300px" max-width="100%"
                                  @load="blogLoaded = true" :class="{
                                    'opacity-100': blogLoaded,
                                    'opacity-75': !blogLoaded,
                                  }">
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="#005f32"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-flex>

                              <v-flex text-start pb-0 style="flex-grow: 1">
                                <v-layout wrap justify-start>
                                  <v-flex xs10 py-2 pt-4 pl-3>
                                    <span class="video-title">
                                      {{ item.title }}
                                    </span>
                                  </v-flex>
                                  <v-flex xs2 class="d-flex align-center justify-end">
                                    <v-menu offset-y>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon>
                                          <v-icon color="black">mdi-dots-vertical</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list>
                                        <v-list-item @click="editItem(item)">
                                          <v-icon small color="primary">mdi-pencil</v-icon>
                                          <v-list-item-content class="pl-3 addChurch">Edit</v-list-item-content>
                                        </v-list-item>

                                        <v-list-item @click.stop="openDeleteDialog(item)">
                                          <v-icon color="red" small>mdi-delete</v-icon>
                                          <v-list-item-content class="pl-3 addChurch">Delete</v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                                <v-flex pt-1>
                                  <v-divider></v-divider>
                                </v-flex>
                                <v-flex px-3 class="live-des mt-1">
                                  <span @click.stop="
                                    item.shortDiscription &&
                                    item.shortDiscription.length > 40 &&
                                    showFullDescription(
                                      item.shortDiscription
                                    )
                                    ">
                                    {{
                                      item.shortDiscription
                                        ? item.shortDiscription.slice(0, 40)
                                        : ""
                                    }}</span>
                                  <span v-if="
                                    item.shortDiscription &&
                                    item.shortDiscription.length > 40
                                  ">....</span>
                                </v-flex>

                                <!-- <v-flex px-3 class="live-des mt-1">
                                                                    <span v-html="item.content"></span>
                                                                  </v-flex> -->
                              </v-flex>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-layout v-else>
                      <v-flex text-center style="font-size: large; font-family: kumbhRegular" class="k">
                        No Data Available
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- description dialog-box -->

    <v-dialog persistent v-model="dialogdes" max-width="800px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Full Description
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="dialogdes = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhRegular" style="color: #000; font-size: 18px">
                  {{ fullDescription }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- description dialog-box -->

    <v-dialog v-model="dialogdes2" max-width="600px">
      <v-card>
        <v-card-title class="card-header">Full Description</v-card-title>
        <v-card-text class="text-des pt-3">
          {{ fullDescription2 }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="font-family: interregular; font-size: 13px; color: white" color="#039379"
            @click="dialogdes2 = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit dialog -->
    <v-dialog v-model="editBlogDialog" max-width="80%">
      <v-card>
        <v-card-title>
          <span class="itemHeading">EDIT WILD BYTES</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="editForm" v-model="valid">
            <v-text-field dense outlined v-model="editedBlog.title" label="Title" required></v-text-field>
            <v-text-field dense outlined v-model="editedBlog.author" label="Author" required></v-text-field>
            <v-menu ref="editMenu" v-model="editMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="editedBlog.uploadedDate" label="Uploaded Date" append-icon="mdi-calendar"
                  readonly v-bind="attrs" v-on="on" dense outlined required></v-text-field>
              </template>
              <v-date-picker v-model="editedBlog.uploadedDate" @input="editMenu = false"></v-date-picker>
            </v-menu>
            <v-textarea v-model="editedBlog.shortDiscription" dense outlined label="Subdescription"
              required></v-textarea>
            <!-- Display Existing Cover Image --><br />
            <v-img v-if="
              editedBlog.images &&
              editedBlog.images.length > 0 &&
              !editImageSelected
            " :src="mediaURL + editedBlog.images[0]" max-height="300px" max-width="100%" class="mb-2"></v-img>
            <!-- Image Upload & Cropper -->
            <v-file-input label="Change Cover Image" dense outlined @change="onEditFileChange2"
              accept="image/*"></v-file-input>
            <Cropper v-if="editImageSelected" ref="editCropper" :src="editImageURL"
              :stencil-props="{ aspectRatio: 16 / 9 }" class="cropper" />
            <!-- Begin new subcontents section for edit -->
            <div>
              <div v-for="(sub, idx) in editedBlog.subcontents" :key="sub._id || idx" class="mb-6 pa-4"
                style="border:1px solid #eee; border-radius:8px;">
                <div class="mb-2">
                  <label style="font-weight:bold;">Content</label>
                  <vue-editor v-model="sub.content" style="font-size: 14px"></vue-editor>
                </div>
                <div class="mb-2">
                  <label style="font-weight:bold;">Image</label>
                  <!-- Show existing image if present and no new image selected -->
                  <v-img v-if="sub.imageUrl && !sub.imageSelected" :src="sub.imageUrl" max-height="200px"
                    max-width="100%" class="mb-2"></v-img>
                  <v-file-input dense outlined accept="image/*" :label="'Upload Image for Content ' + (idx + 1)"
                    @change="onEditSubcontentFileChange($event, idx)" :show-size="false"
                    hide-details="auto"></v-file-input>
                  <cropper v-if="sub.imageSelected" :ref="'editSubCropper' + idx" :src="sub.imageURL"
                    :resize-image="true" :background="true" />
                </div>
                <div class="mb-2">
                  <label style="font-weight:bold;">Image Caption</label>
                  <v-text-field dense outlined v-model="sub.imagecaption" label="Image Caption"></v-text-field>
                </div>
                <div v-if="editedBlog.subcontents.length > 1" class="text-right">
                  <v-btn small color="red" text @click="removeEditSubcontent(idx)">
                    Remove
                  </v-btn>
                </div>
              </div>
              <v-btn color="#005f32" outlined small @click="addEditSubcontent">
                Add More
              </v-btn>
            </div>
            <!-- End new subcontents section for edit -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="editBlogDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="updateBlog">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->

    <v-dialog persistent v-model="deletedialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  DELETE WILD BYTES
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="deletedialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px">Are you sure you want to delete this
                  byte?</span>
              </v-flex>

              <v-flex xs12 align-self-center text-right pt-3>
                <v-btn @click="confirmDelete" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Delete </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    Cropper,
    VueEditor,
  },
  data() {
    return {
      ServerError: false,
      bloglist: [],
      formErrors: [],
      showSnackBar: false,
      deletedialog: false,
      itemToDelete: null,
      dialogdes: false,
      dialogdes2: false,
      blogLoaded: false,
      timeout: 5000,
      msg: "",
      appLoading: false,
      page: 1,
      currentPage: 1,
      pages: 0,
      limit: 10,
      fullDescription: "",
      fullDescription2: "",
      addBlog: false,
      valid: false,
      title: "",
      author: "",
      subDescription: "",
      subcontents: [
        {
          content: "",
          imageFile: null,
          imageURL: "",
          imageSelected: false,
          imagecaption: "",
        },
      ],
      imageSelected: false,
      imageURL: "",
      imageFile: null,
      editBlogDialog: false,
      editedBlog: {
        _id: null,
        title: "",
        author: "",
        shortDiscription: "",
        images: [],
        subcontents: [
          {
            content: "",
            imageFile: null,
            imageURL: "",
            imageUrl: "", // for existing image url
            imageSelected: false,
            imagecaption: "",
          },
        ],
      },
      editImageSelected: false, // To check if a new image is selected
      editImageURL: "",

      imageQuality: 0.7, // Default image quality
      maxImageWidth: 1200, // Default max width
      maxImageHeight: 800, // Default max height
      uploadedDate: '', // For the date picker
      menu: false,      // For the date picker menu
      today: new Date().toISOString().substr(0, 10), // For max date
      editMenu: false, // For edit dialog date picker

    };
  },

  //   computed: {
  //   filteredHeaders() {
  //     if (this.userRole === 'subadmin') {
  //       return this.headers.filter(header => header.value !== '_id');
  //     }
  //     return this.headers;
  //   }
  // },
  mounted() {
    this.getData();
  },
  methods: {
    //     redirectToViewPage(item) {
    //   this.$router.push(
    //     `/Blogs/viewWildByte?slug=${item.slug}`
    //   );
    // },
    redirectToViewPage(item) {
      this.$router.push(`/Blogs/viewWildByte/${item.slug}`);
    },
    onFileChange(file) {
      if (file) {
        this.imageURL = URL.createObjectURL(file);
        this.imageSelected = true;
        // Log original file size
        console.log("Original file size:", file.size / (1024 * 1024), "MB");
      } else {
        console.error("No file selected.");
      }
    },
    validateForm() {
      this.formErrors = [];
      if (!this.title) {
        this.formErrors.push("Title is required.");
      }
      if (!this.author) {
        this.formErrors.push("Author is required.");
      }
      if (!this.uploadedDate) {
        this.formErrors.push("Uploaded date is required.");
      }
      if (!this.subDescription) {
        this.formErrors.push("Sub description is required.");
      }
      // Validate subcontents
      if (!this.subcontents.length) {
        this.formErrors.push("At least one content section is required.");
      }
      this.subcontents.forEach((sub, idx) => {
        if (!sub.content && !sub.imageSelected) {
          this.formErrors.push(`Content or image required in section ${idx + 1}.`);
        }
      });
      if (!this.imageSelected) {
        this.formErrors.push("Cover Image is required.");
      }
      if (this.formErrors.length > 0) {
        this.msg = this.formErrors.join(" ");
        this.showSnackBar = true;
        return false;
      }
      return true;
    },
    processCanvasImage(canvas, callback) {
      // Get original dimensions
      const originalWidth = canvas.width;
      const originalHeight = canvas.height;

      // Check if resizing is needed
      if (
        originalWidth > this.maxImageWidth ||
        originalHeight > this.maxImageHeight
      ) {
        // Calculate new dimensions maintaining aspect ratio
        let newWidth = originalWidth;
        let newHeight = originalHeight;

        if (newWidth > this.maxImageWidth) {
          newHeight = (this.maxImageWidth / newWidth) * newHeight;
          newWidth = this.maxImageWidth;
        }

        if (newHeight > this.maxImageHeight) {
          newWidth = (this.maxImageHeight / newHeight) * newWidth;
          newHeight = this.maxImageHeight;
        }

        // Create a new canvas with the desired dimensions
        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = newWidth;
        resizedCanvas.height = newHeight;

        // Draw the original canvas onto the resized one
        const ctx = resizedCanvas.getContext("2d");
        ctx.drawImage(canvas, 0, 0, newWidth, newHeight);

        // Generate blob with compression
        resizedCanvas.toBlob(callback, "image/jpeg", this.imageQuality);
      } else {
        // No resizing needed, just compress
        canvas.toBlob(callback, "image/jpeg", this.imageQuality);
      }
    },
    async addBlogs() {
      this.appLoading = true;
      if (!this.validateForm()) {
        this.appLoading = false;
        return;
      }
      // Prepare subcontents array with processed images
      const processSubcontentImages = async () => {
        const processed = [];
        for (let i = 0; i < this.subcontents.length; i++) {
          const sub = this.subcontents[i];
          let imageBlob = null;
          if (sub.imageSelected && this.$refs['subCropper' + i]) {
            // Vue refs for v-for are arrays if multiple, so handle both cases
            let cropperRef = this.$refs['subCropper' + i];
            if (Array.isArray(cropperRef)) cropperRef = cropperRef[0];
            const canvas = cropperRef.getResult().canvas;
            if (canvas) {
              imageBlob = await new Promise((resolve) => {
                this.processCanvasImage(canvas, (blob) => resolve(blob));
              });
            }
          }
          processed.push({
            content: sub.content,
            image: imageBlob,
            imagecaption: sub.imagecaption,
          });
        }
        return processed;
      };

      // Process cover image
      let coverImageBlob = null;
      if (this.$refs.cropper) {
        const canvas = this.$refs.cropper.getResult().canvas;
        if (canvas) {
          coverImageBlob = await new Promise((resolve) => {
            this.processCanvasImage(canvas, (blob) => resolve(blob));
          });
        }
      }

      // Prepare FormData
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("author", this.author);
      formData.append("uploadedDate", this.uploadedDate);
      formData.append("subdiscription", this.subDescription);
      // formData.append("content", this.content); // REMOVE
      // Add cover image
      if (coverImageBlob) {
        formData.append("images", coverImageBlob);
      }
      // Add subcontents as array of objects (with images as blobs)
      const processedSubcontents = await processSubcontentImages();

      const subcontentsForJson = [];
      processedSubcontents.forEach((sub, idx) => {
        // Use the original file name if available, otherwise empty string
        let imageFileName = "";
        if (this.subcontents[idx].imageFile && this.subcontents[idx].imageFile.name) {
          imageFileName = this.subcontents[idx].imageFile.name;
        }
        subcontentsForJson.push({
          content: sub.content,
          image: imageFileName,
          imagecaption: sub.imagecaption,
        });
        // Append the image Blob as binary if it exists
        if (sub.image) {
          formData.append("subcontentimage", sub.image, imageFileName || `subcontent${idx}.jpg`);
        }
      });

      formData.append("subcontents", JSON.stringify(subcontentsForJson));

      // Console log FormData entries for debugging (especially images)
      for (let pair of formData.entries()) {
        if (pair[1] instanceof Blob) {
          console.log(pair[0], '[Blob]', pair[1].type, pair[1].size, pair[1].name || '');
        } else {
          console.log(pair[0], pair[1]);
        }
      }

      try {
        const response = await axios.post(
          "/employee/blog/add",
          formData,
          {
            headers: { "x-auth-token": localStorage.getItem("token") },
          }
        );
        if (response.data.status) {
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.addBlog = false;
          // Clear form fields after successful addition
          this.title = "";
          this.author = "";
          this.uploadedDate = "";
          this.subDescription = "";
          this.imageURL = "";
          this.imageSelected = false;
          this.subcontents = [
            {
              content: "",
              imageFile: null,
              imageURL: "",
              imageSelected: false,
              imagecaption: "",
            },
          ];
          this.getData();
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      } catch (error) {
        console.error("Error adding blog:", error);
        // Check if error response has a message from backend
        if (error.response && error.response.data && error.response.data.msg) {
          this.msg = error.response.data.msg;
        } else {
          this.msg = "An error occurred while adding the blog.";
        }
        this.showSnackBar = true;
      } finally {
        this.appLoading = false;
      }
    },

    editItem(item) {
  const subcontents = (item.subcontents && item.subcontents.length
    ? item.subcontents.map(sub => ({
      content: sub.content || "",
      imageFile: null,
      imageURL: "",
      imageUrl: (sub.image && Array.isArray(sub.image) && sub.image.length)
        ? this.mediaURL + sub.image[0]
        : "",
      imageSelected: false,
      imagecaption: sub.imagecaption || "",
      _id: sub._id || Math.random().toString(36),
    }))
    : [
      {
        content: "",
        imageFile: null,
        imageURL: "",
        imageUrl: "",
        imageSelected: false,
        imagecaption: "",
      },
    ]);
  this.editedBlog = { ...item, subcontents };
  // Convert ISO date to YYYY-MM-DD for the date picker
  if (item.uploadedDate) {
    const d = new Date(item.uploadedDate);
    this.editedBlog.uploadedDate = !isNaN(d) ? d.toISOString().substr(0, 10) : "";
  } else {
    this.editedBlog.uploadedDate = "";
  }
  this.editImageSelected = false;
  this.editBlogDialog = true;
},

    // Handle image change in edit form
    onEditFileChange(file) {
      if (file) {
        this.editImageURL = URL.createObjectURL(file);
        this.editImageSelected = true;
        console.log(
          "Original edit file size:",
          file.size / (1024 * 1024),
          "MB"
        );
      }
    },
    onEditFileChange2(file) {
      if (file) {
        this.editImageURL = URL.createObjectURL(file);
        this.editImageSelected = true; // Show cropper when a new image is selected
        console.log(
          "Original edit file size:",
          file.size / (1024 * 1024),
          "MB"
        );
      } else {
        console.error("No file selected.");
      }
    },
    addEditSubcontent() {
      this.editedBlog.subcontents.push({
        content: "",
        imageFile: null,
        imageURL: "",
        imageUrl: "",
        imageSelected: false,
        imagecaption: "",
      });
    },
    removeEditSubcontent(idx) {
      this.editedBlog.subcontents.splice(idx, 1);
    },
    onEditSubcontentFileChange(file, idx) {
      if (file) {
        this.$set(this.editedBlog.subcontents[idx], "imageURL", URL.createObjectURL(file));
        this.$set(this.editedBlog.subcontents[idx], "imageFile", file);
        this.$set(this.editedBlog.subcontents[idx], "imageSelected", true);
      } else {
        this.$set(this.editedBlog.subcontents[idx], "imageURL", "");
        this.$set(this.editedBlog.subcontents[idx], "imageFile", null);
        this.$set(this.editedBlog.subcontents[idx], "imageSelected", false);
      }
    },
    async updateBlog() {
      this.appLoading = true;
      // Basic validation checks
      if (
        !this.editedBlog.title ||
        !this.editedBlog.author ||
        !this.editedBlog.shortDiscription ||
        !this.editedBlog.subcontents.length
      ) {
        this.msg = "All fields are required.";
        this.showSnackBar = true;
        this.appLoading = false;
        return;
      }
      // Validate subcontents
      for (let i = 0; i < this.editedBlog.subcontents.length; i++) {
        const sub = this.editedBlog.subcontents[i];
        if (!sub.content && !sub.imageSelected && !sub.imageUrl) {
          this.msg = `Content or image required in section ${i + 1}.`;
          this.showSnackBar = true;
          this.appLoading = false;
          return;
        }
      }
      let formData = new FormData();
      formData.append("title", this.editedBlog.title);
      formData.append("author", this.editedBlog.author);
      formData.append("uploadedDate", this.editedBlog.uploadedDate);
      formData.append("slug", this.editedBlog.slug);
      formData.append("subdiscription", this.editedBlog.shortDiscription);

      // Process cover image if changed
      if (this.editImageSelected && this.$refs.editCropper) {
        const canvas = this.$refs.editCropper.getResult().canvas;
        if (canvas) {
          await new Promise((resolve) => {
            canvas.toBlob((blob) => {
              formData.append("images", blob);
              resolve();
            }, "image/jpeg", this.imageQuality);
          });
        }
      }

      // Process subcontents images
      const processEditSubcontentImages = async () => {
        const processed = [];
        for (let i = 0; i < this.editedBlog.subcontents.length; i++) {
          const sub = this.editedBlog.subcontents[i];
          let imageBlob = null;
          let imageFileName = "";
          if (sub.imageSelected && this.$refs['editSubCropper' + i]) {
            let cropperRef = this.$refs['editSubCropper' + i];
            if (Array.isArray(cropperRef)) cropperRef = cropperRef[0];
            const canvas = cropperRef.getResult().canvas;
            if (canvas) {
              imageBlob = await new Promise((resolve) => {
                this.processCanvasImage(canvas, (blob) => resolve(blob));
              });
            }
            if (sub.imageFile && sub.imageFile.name) {
              imageFileName = sub.imageFile.name;
            } else {
              imageFileName = `subcontent${i}.jpg`;
            }
          } else if (sub.imageUrl) {
            // Existing image, extract filename from URL
            imageFileName = sub.imageUrl.replace(this.mediaURL, "");
          }
          processed.push({
            content: sub.content,
            image: imageFileName,
            imagecaption: sub.imagecaption,
            imageBlob,
          });
        }
        return processed;
      };

      const processedSubcontents = await processEditSubcontentImages();

      // Append subcontents JSON and images
      const subcontentsForJson = [];
      processedSubcontents.forEach((sub, idx) => {
        subcontentsForJson.push({
          content: sub.content,
          image: sub.image,
          imagecaption: sub.imagecaption,
        });
        if (sub.imageBlob) {
          formData.append("subcontentimage", sub.imageBlob, sub.image || `subcontent${idx}.jpg`);
        }
      });
      formData.append("subcontents", JSON.stringify(subcontentsForJson));

      try {
        const response = await axios.post(`/employee/blog/edit`, formData, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        });
        if (response.data.status) {
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.getData();
          this.editBlogDialog = false;
          this.appLoading = false;
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.appLoading = false;
        }
      } catch (error) {
        console.error("Error updating blog:", error);
        // Check if error response has a message from backend
        if (error.response && error.response.data && error.response.data.msg) {
          this.msg = error.response.data.msg;
        } else {
          this.msg = "An error occurred while updating the blog.";
        }
        this.showSnackBar = true;
        this.appLoading = false;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/employee/blog/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        //   params: {
        //     limit: this.limit,
        //     page: this.currentPage,
        //     username: this.search,
        //   },
      })
        .then((response) => {
          this.appLoading = false;
          this.bloglist = response.data.data;
          //this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          // Check if error response has a message from backend
          if (err.response && err.response.data && err.response.data.msg) {
            this.msg = err.response.data.msg;
            this.showSnackBar = true;
          }
          console.log(err);
        });
    },
    showFullDescription(shortDiscription) {
      this.fullDescription = shortDiscription;
      this.dialogdes = true;
    },
    showFullDescription2(content) {
      this.fullDescription2 = content;
      this.dialogdes2 = true;
    },
    //      edit() {
    //     var data = {};
    //     data["catName"] = this.editingitem.catName;
    //     data["priority"] = this.editingitem.priority;
    //     data["desc"] = this.editingitem.desc;
    //     data["id"] = this.editingitem._id;
    //     axios({
    //       url: "/v1/admin/edit/project/category",
    //       method: "PUT",
    //       data: data,
    //       headers: {
    //         token: localStorage.getItem("token"),
    //       },
    //     })
    //       .then((response) => {
    //         this.appLoading = false;
    //         if (response.data.status) {
    //         //   this.msg = response.data.msg;
    //         //   this.showSnackBar = true;
    //         //   this.editdialog = false;
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //         this.editdialog = false;
    //         this.getData();
    //         } else {
    //             this.msg = response.data.msg;
    //             this.showSnackBar = true;
    //         }
    //       })
    //       .catch((err) => {
    //         this.appLoading = false;
    //         this.ServerError = true;
    //         console.log(err);
    //       });
    //   },

    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.deletedialog = true;
    },
    confirmDelete() {
      if (this.itemToDelete) {
        this.deleteItem(this.itemToDelete);
      }
      this.deletedialog = false;
    },
    deleteItem(r) {
      this.appLoading = true;
      var data = {};
      data["id"] = r._id;
      axios({
        url: "/employee/blog/delete",
        method: "post",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.appLoading = false;
            this.showSnackBar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          // Check if error response has a message from backend
          if (err.response && err.response.data && err.response.data.msg) {
            this.msg = err.response.data.msg;
            this.showSnackBar = true;
          }
          console.log(err);
        });
    },
    addSubcontent() {
      this.subcontents.push({
        content: "",
        imageFile: null,
        imageURL: "",
        imageSelected: false,
        imagecaption: "",
      });
    },
    removeSubcontent(idx) {
      this.subcontents.splice(idx, 1);
    },
    onSubcontentFileChange(file, idx) {
      if (file) {
        this.$set(this.subcontents[idx], "imageURL", URL.createObjectURL(file));
        this.$set(this.subcontents[idx], "imageFile", file);
        this.$set(this.subcontents[idx], "imageSelected", true);
      } else {
        this.$set(this.subcontents[idx], "imageURL", "");
        this.$set(this.subcontents[idx], "imageFile", null);
        this.$set(this.subcontents[idx], "imageSelected", false);
      }
    },
  },
};
</script>



<style scoped>
.dialog-card {
  font-family: interbold;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.dialog-icon {
  animation: pulse 1s infinite alternate;
}

.dialog-button {
  min-width: 120px;
}

@keyframes pulse {
  from {
    transform: scale(1);
    opacity: 0.7;
  }

  to {
    transform: scale(1.1);
    opacity: 1;
  }
}

.video-card {
  margin: 10px;
  cursor: pointer;
}

.video-title {
  font-size: 14px;
  font-family: kumbhBold;
  text-transform: uppercase;
}

.video-duration {
  color: grey;
  font-size: 12px;
}

.card-header {
  background-color: #f5f5f5;
  padding: 16px;
  font-family: kumbhMedium;
  border-bottom: 1px solid #e0e0e0;
}

.centered-text {
  text-align: center;
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: white;
  opacity: 0.8;
  border-radius: 4px;
}
</style>